import { StyleRules } from '@material-ui/core/styles';
import { SwitchClassKey } from '@material-ui/core/Switch';

import { core as theme } from '../styles/core';

export const MuiSwitch: Partial<StyleRules<SwitchClassKey>> = {
  switchBase: {
    '&.Mui-disabled': {
      color: theme.palette.common.white,
    },
    '&.Mui-checked + .MuiSwitch-track': {
      opacity: 1,
    },
    '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.grey[100],
      opacity: 1,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: theme.palette.grey[100],
      opacity: 1,
    },
  },
  track: {
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    border: `1px solid ${theme.palette.grey.A200}`,
  },
  colorPrimary: {
    '&.Mui-disabled': {
      color: theme.palette.common.white,
    },
    '&.Mui-checked': {
      color: theme.palette.common.white,
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.lighter,
      opacity: 1,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: theme.palette.grey[100],
      opacity: 1,
    },
  },
  colorSecondary: {
    '&.Mui-disabled': {
      color: theme.palette.common.white,
    },
    '&.Mui-checked': {
      color: theme.palette.common.white,
    },
    '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.secondary.lighter,
      opacity: 1,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: theme.palette.grey[100],
      opacity: 1,
    },
  },
};
